export default "__VITE_ASSET__23e36540__"